import {Action, lazyGet} from "@dp-instant/core";
import {SocialFlowAction} from "@dp-instant/gameflow";
import {
    IVibrationManager,
    TypesApp,
    TypesDevice,
    TypesFlow,
    TypesSocial
} from "@dp-instant/interfaces";
import {AppModel} from "@dp-instant/social";
import {TypesGame} from "@game/TypesGame";
import {SkinManager} from "@game/coregame/managers/SkinManager";
import {CookieModel} from "@game/coregame/model/CookieModel";
import {GameModel} from "@game/coregame/model/GameModel";
import {inject, injectable} from "inversify";
import {LevelStartActionSIO} from "./LevelStartActionSIO";
import {SetCalculatedConstantValuesAction} from "./SetCalculatedConstantValuesAction";

@injectable()
export class MainAction extends SocialFlowAction {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesFlow.LevelStart)
    private readonly levelStart: LevelStartActionSIO;

    @inject(TypesGame.cookieModel)
    private cookies: CookieModel;

    @inject(TypesApp.model)
    protected readonly appModel: AppModel;

    protected async beforeLaunch(): Promise<void> {
        lazyGet<Action>(TypesDevice.initAction)?.run();
        await super.beforeLaunch();
    }

    protected async launch() {
        // Read remote config if it needs
        await lazyGet<Action>(TypesGame.actions.readRemoteConfigAction)?.run();

        const leaderboardsPromise = this.social.syncLeaderboards();
        if (process.env.NODE_ENV === "development") {
            (window as any).v_model = this.model;
        }
        lazyGet<IVibrationManager>(TypesSocial.vibrationManager)?.init();
        await this.cookies.sync();
        if (!this.social.inSolo) {
            // context leaderboard must be synced to load level data
            await leaderboardsPromise;
        }

        lazyGet<SetCalculatedConstantValuesAction>(SetCalculatedConstantValuesAction)?.run();

        lazyGet<SkinManager>(TypesGame.skinManager)?.updateSkins();
        await this.levelStart.run();
    }
}
